export default __webpack_public_path__ + "static/media/icon-woman-baby.b60feeb1.png";